import { render, staticRenderFns } from "./OnBoardingInvitationCardForCancelled.vue?vue&type=template&id=e7cd6a5c&scoped=true"
import script from "./OnBoardingInvitationCardForCancelled.vue?vue&type=script&lang=ts"
export * from "./OnBoardingInvitationCardForCancelled.vue?vue&type=script&lang=ts"
import style0 from "./OnBoardingInvitationCardForCancelled.vue?vue&type=style&index=0&id=e7cd6a5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7cd6a5c",
  null
  
)

export default component.exports